import { Route, Routes } from "react-router-dom";
import Layout from "../layout/Layout";
import { routes } from "./Route";
import ErrorPage from "../pages/error-page/ErrorPage";

const LayoutRoutes = () => {
  return (
    <Routes>
      {routes.map(({ path, Component }, i) => (
        <Route element={<Layout />} key={i}>
          <Route path={path} element={Component} />
        </Route>
      ))}
      
       <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default LayoutRoutes;